module.exports = __webpack_public_path__ + "static/media/hab3-1.9549104d.jpg";